import React, { useState, useCallback } from 'react';
import { Card, CardContent, Typography, TextField, MenuItem } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { useSelector, shallowEqual } from 'react-redux';

import { API_DOMAIN } from '../../../../constants';
import AlertCompanyDetail from '../../products/components/AlertCompanyDetail';
import { ICompany } from '../../../../interfaces/companies';
import { thousands } from '../../../../utils/utils';
import { IOrder, IOrderItem } from '../../../../interfaces/order';
import ButtonWithLoader from '../../../../components/ui/Buttons/ButtonWithLoader';
import AlertCompanyPayments from './AlertCompanyPayments';
import { useStylesOrderTable } from '../hooks/useStyles';
import CompanyInfo from './CompanyInfo';
import { useDefineUserRole } from '../../../../hooks';
import { IAppState } from '../../../../store/rootDuck';

interface IProps {
  orders: IOrder | null;
  selectAction: (id: any) => void;
  selectedId: number;
  editStatus: (id: any) => void;
}

const OrderTable: React.FC<IProps> = ({ orders, selectedId, selectAction, editStatus }) => {
  const classes = useStylesOrderTable();
  const me = useSelector(({ profile }: IAppState) => profile.me, shallowEqual);
  const isVendor = useDefineUserRole(me, 'ROLE_VENDOR');
  const isBuyer = useDefineUserRole(me, 'ROLE_BUYER');
  const intl = useIntl();
  const [isOpenCompanyDialog, setOpenCompanyDialog] = useState(false);
  const [isOpenPaymentDialog, setOpenPaymentDialog] = useState(false);
  const [isOpenVendorPaymentDialog, setOpenVendorPaymentDialog] = useState(false);
  const [companyAndItems, setCompanyAndItems] = useState<{
    company: ICompany;
    items: IOrderItem[];
    id: number;
    deliveryCost: number;
  }>();
  const [vendorAndItems, setvendorAndItems] = useState<{
    company: ICompany;
    items: IOrderItem[];
    id: number;
    deliveryCost: number;
  }>();
  const [com, setCompany] = useState<ICompany>();

  const translates: { [type: string]: string } = {
    paid: intl.formatMessage({ id: 'ORDER.TYPE.PAYED' }),
    not_paid: intl.formatMessage({ id: 'ORDER.TYPE.NOT_PAID' }),
  };

  const orderTypeList: { type: string }[] = [{ type: 'paid' }, { type: 'not_paid' }];

  const getTotalPriceByOrder = (orderItems: IOrderItem[]) => {
    let totalPrice = 0;
    orderItems.forEach(item => {
      totalPrice += item.product.price * item.count;
    });
    return totalPrice;
  };

  const hendlePayments = useCallback((order: IOrder) => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { company, items, id, delivery_cost } = order;
    setCompanyAndItems({ company, items, id, deliveryCost: delivery_cost });
    setOpenPaymentDialog(true);
  }, []);

  const hendlePaymentsVendor = useCallback((order?: IOrder | null) => {
    if (!order) return;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { company, items, id, delivery_cost } = order;
    setvendorAndItems({ company, items, id, deliveryCost: delivery_cost });
    setOpenVendorPaymentDialog(true);
  }, []);

  const openModalCompany = useCallback((company: ICompany) => {
    setCompany(company);
    setOpenCompanyDialog(true);
  }, []);

  const totalPriceByOrder = (orderItems: IOrderItem[]) => {
    let totalOrderPrice = 0;
    orderItems.forEach(item => {
      totalOrderPrice += item.product.price * item.count;
    });
    return totalOrderPrice;
  };

  return (
    <>
      {orders &&
        orders.orders?.map(order => (
          <>
            <CompanyInfo
              compBrand={order.company.brand}
              compName={order.company.name}
              rightTitle='О продавце'
              onPress={() => openModalCompany(order.company)}
            />

            {order.items.map(item => {
              return (
                <Card className={classes.itemCard}>
                  <CardContent className={classes.cardContent}>
                    <div className={classes.contentWrapper}>
                      <div>
                        {item.product.photos && item.product.photos.length > 0 ? (
                          <img
                            alt=''
                            src={`${API_DOMAIN}/${
                              item?.product?.photos?.find((el: any) => el.main)?.small ||
                              item.product.photos[0].small
                            }`}
                            className={classes.img}
                          />
                        ) : (
                          <img
                            alt=''
                            src='../../../images/placeholder.png'
                            className={classes.img}
                          />
                        )}
                      </div>

                      <div className={classes.infoWrapper}>
                        <div className={classes.infoButtonsWrapper}>
                          <div className={classes.nameWrapper}>
                            <Link
                              to={`${
                                //   isAdmin
                                //     ? `/products/edit/${item.product.id}`
                                // :
                                `/viewproduct/${item.product.id}`
                              }`}
                              className={classes.link}
                            >
                              {item.product.name}
                            </Link>
                          </div>

                          <div className={classes.priceWrapper}>
                            <Typography className={classes.priceValue}>
                              {thousands(String(item.product.price))} руб.
                            </Typography>
                            <Typography className={classes.priceLabel}>
                              Цена за 1 шт.
                            </Typography>
                          </div>

                          <div className={classes.countWrapper}>
                            <Typography className={classes.countValue}>
                              Х {item.count}
                            </Typography>
                          </div>

                          <div className={classes.priceWrapper}>
                            <Typography className={classes.sumValue}>
                              {thousands(String(+item.product.price * item.count))} руб.
                            </Typography>
                            <Typography className={classes.sumLabel}>Сумма</Typography>
                          </div>
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              );
            })}

            <Card className={classes.totalCard}>
              <CardContent className={classes.totalCardContent}>
                <div>
                  <div className={classes.totalRow}>
                    <Typography className={classes.totalLabel}>ИТОГО ПО ПРОДАВЦУ:</Typography>

                    <Typography className={classes.totalAmount}>
                      {thousands(String(getTotalPriceByOrder(order.items)))} руб.
                    </Typography>
                  </div>
                  <div className={classes.totalRow}>
                    <Typography className={classes.totalLabel}>СТОИМОСТЬ ДОСТАВКИ:</Typography>

                    <Typography className={classes.totalAmount}>
                      {thousands(
                        String(order.delivery_cost ? order.delivery_cost.toFixed(2) : 0)
                      )}{' '}
                      руб.
                    </Typography>
                  </div>
                </div>

                <Typography className={classes.paymentStatus}>
                  {translates[order.payment_status]}
                </Typography>

                <ButtonWithLoader
                  style={{ background: '#d01c1f' }}
                  onPress={() => hendlePayments(order)}
                >
                  <Typography className={classes.btnText}>Реквизиты для оплаты</Typography>
                </ButtonWithLoader>
              </CardContent>
            </Card>
          </>
        ))}
      <>
        {me?.is_admin && orders && orders.items && orders.items.length > 0 && (
          <CompanyInfo
            compBrand={orders.items[0]?.product?.company?.brand}
            compName={orders.items[0]?.product?.company?.name}
            rightTitle='О продавце'
            onPress={() => {
              const company = orders.items[0]?.product?.company;
              if (company) {
                openModalCompany(company);
              }
            }}
          />
        )}
        {isBuyer && orders?.items && orders?.items.length > 0 && (
          <CompanyInfo
            compBrand={orders?.company?.brand}
            compName={orders?.company?.name}
            rightTitle='О продавце'
            onPress={() => {
              const company = orders?.company;
              if (company) {
                openModalCompany(company);
              }
            }}
          />
        )}

        {orders &&
          orders?.items?.map(order => {
            return (
              <Card className={classes.itemCard}>
                <CardContent className={classes.cardContent}>
                  <div className={classes.contentWrapper}>
                    <div>
                      {order.product.photos && order.product.photos.length > 0 ? (
                        <img
                          alt=''
                          src={`${API_DOMAIN}/${
                            order?.product?.photos?.find((el: any) => el.main)?.small ||
                            order.product.photos[0].small
                          }`}
                          className={classes.img}
                        />
                      ) : (
                        <img
                          alt=''
                          src='../../../images/placeholder.png'
                          className={classes.img}
                        />
                      )}
                    </div>

                    <div className={classes.infoWrapper}>
                      <div className={classes.infoButtonsWrapper}>
                        <div className={classes.nameWrapper}>
                          <Link
                            to={`${`/viewproduct/${order.product.id}`}`}
                            className={classes.link}
                          >
                            {order.product.name}
                          </Link>
                        </div>

                        <div className={classes.priceWrapper}>
                          <Typography className={classes.priceValue}>
                            {thousands(String(order.product.price))} руб.
                          </Typography>
                          <Typography className={classes.priceLabel}>Цена за 1 шт.</Typography>
                        </div>

                        <div className={classes.countWrapper}>
                          <Typography className={classes.countValue}>
                            Х {order.count}
                          </Typography>
                        </div>

                        <div className={classes.priceWrapper}>
                          <Typography className={classes.sumValue}>
                            {thousands(String(+order.product.price * order.count))} руб.
                          </Typography>

                          <Typography className={classes.sumLabel}>Сумма</Typography>
                        </div>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}

        {isVendor && (
          <Card className={classes.totalCard}>
            <CardContent className={classes.totalCardContent}>
              <div className={classes.totalRow}>
                <Typography className={classes.totalLabel}>ИТОГО ПО ПРОДАВЦУ:</Typography>

                <Typography className={classes.totalAmount}>
                  {thousands(String(totalPriceByOrder(orders?.items || [])))} руб.
                </Typography>
              </div>

              <div>
                {selectedId !== orders?.id ? (
                  <Typography
                    className={classes.paymentStatus}
                    style={{ cursor: isBuyer ? 'none' : 'pointer' }}
                  >
                    <p onClick={() => selectAction(orders?.id)}>
                      {translates[orders?.payment_status || '']}
                    </p>
                  </Typography>
                ) : (
                  <TextField
                    select
                    margin='none'
                    value={orders?.payment_status}
                    onChange={event => {
                      editStatus({
                        id: orders.id,
                        page: 1,
                        perPage: 20,
                        data: {
                          payment_status: event.target.value,
                          items: orders.items.map(e => ({
                            count: e.count,
                            product_id: e.product.id,
                          })),
                        },
                        userId: me?.id,
                        root: me?.is_admin,
                      });
                      selectAction(-1);
                    }}
                    variant='outlined'
                    className={classes.typeList}
                    size='small'
                  >
                    {orderTypeList &&
                      orderTypeList.map(option => (
                        <MenuItem key={option.type} value={option.type}>
                          {translates[option.type]}
                        </MenuItem>
                      ))}
                  </TextField>
                )}
              </div>

              <ButtonWithLoader
                style={{ background: '#d01c1f' }}
                onPress={() => hendlePaymentsVendor(orders)}
              >
                <Typography className={classes.btnText}>Реквизиты для оплаты</Typography>
              </ButtonWithLoader>
            </CardContent>
          </Card>
        )}
        {(me?.is_admin || isBuyer) &&
          thousands(String(totalPriceByOrder(orders?.items || []))) !== '0' && (
            <Card className={classes.totalCard}>
              <CardContent className={classes.totalCardContent}>
                <div>
                  <div className={classes.totalRow}>
                    <Typography className={classes.totalLabel}>ИТОГО ПО ПРОДАВЦУ:</Typography>

                    <Typography className={classes.totalAmount}>
                      {thousands(String(totalPriceByOrder(orders?.items || [])))} руб.
                    </Typography>
                  </div>
                  <div className={classes.totalRow}>
                    <Typography className={classes.totalLabel}>СТОИМОСТЬ ДОСТАВКИ:</Typography>

                    <Typography className={classes.totalAmount}>
                      {thousands(
                        String(orders?.delivery_cost ? orders?.delivery_cost.toFixed(2) : 0)
                      )}{' '}
                      руб.
                    </Typography>
                  </div>
                </div>

                <div>
                  {selectedId !== orders?.id ? (
                    <Typography
                      className={classes.paymentStatus}
                      style={{ cursor: isBuyer ? 'none' : 'pointer' }}
                    >
                      <p onClick={() => selectAction(orders?.id)}>
                        {translates[orders?.payment_status || '']}
                      </p>
                    </Typography>
                  ) : (
                    <TextField
                      select
                      margin='none'
                      value={orders?.payment_status}
                      onChange={event => {
                        editStatus({
                          id: orders.id,
                          page: 1,
                          perPage: 20,
                          data: {
                            payment_status: event.target.value,
                            items: orders.items.map(e => ({
                              count: e.count,
                              product_id: e.product.id,
                            })),
                          },
                          userId: me?.id,
                          root: me?.is_admin,
                        });
                        selectAction(-1);
                      }}
                      variant='outlined'
                      className={classes.typeList}
                      size='small'
                    >
                      {orderTypeList &&
                        orderTypeList.map(option => (
                          <MenuItem key={option.type} value={option.type}>
                            {translates[option.type]}
                          </MenuItem>
                        ))}
                    </TextField>
                  )}
                </div>

                <ButtonWithLoader
                  style={{ background: '#d01c1f' }}
                  onPress={() => hendlePaymentsVendor(orders)}
                >
                  <Typography className={classes.btnText}>Реквизиты для оплаты</Typography>
                </ButtonWithLoader>
              </CardContent>
            </Card>
          )}
        <AlertCompanyDetail
          open={isOpenCompanyDialog}
          message={intl.formatMessage({ id: 'FILE.IMPORT.ALERT.TEXT' })}
          company={com}
          handleClose={() => {
            setOpenCompanyDialog(false);
          }}
        />

        <AlertCompanyPayments
          open={isOpenPaymentDialog}
          company={companyAndItems?.company}
          prices={companyAndItems?.items}
          orderId={companyAndItems?.id}
          deliveryCost={companyAndItems?.deliveryCost}
          handleClose={() => {
            setOpenPaymentDialog(false);
          }}
        />

        <AlertCompanyPayments
          open={isOpenVendorPaymentDialog}
          company={vendorAndItems?.company}
          prices={vendorAndItems?.items}
          orderId={vendorAndItems?.id}
          deliveryCost={vendorAndItems?.deliveryCost}
          handleClose={() => {
            setOpenVendorPaymentDialog(false);
          }}
        />

        <AlertCompanyPayments
          open={isOpenPaymentDialog}
          company={companyAndItems?.company}
          prices={companyAndItems?.items}
          orderId={companyAndItems?.id}
          deliveryCost={companyAndItems?.deliveryCost}
          handleClose={() => {
            setOpenPaymentDialog(false);
          }}
        />
      </>
    </>
  );
};

export default OrderTable;
